<template>
  	<v-container id="hopper_carousel" class="raporto-wrapper">
    	<div class="parent-title-wrapper">{{getStateWithParam(currentMenuParent.name)}}</div>
		<hooper
			class="hooper-navigation"
			:infiniteScroll="false"
			:itemsToShow="1"
			:centerMode="true"
			:wheelControl="false"
			:initialSlide="currentMenuIndex"
			@slide="navigateToRoute"
			ref="menuCarousel"
		>
			<slide v-for="(item, index) in menu" :key="index" :index="index">
				<InnerMenuCarousel :menuItemToPresent="item" />
			</slide>
			<hooper-pagination v-if=" menu.length > 1 " slot="hooper-addons"></hooper-pagination>
		</hooper>
		<router-view></router-view>
  	</v-container>
</template>

<script >
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import "hooper/dist/hooper.css";

import InnerMenuCarousel from "./InnerMenuCarousel";


function getExcluded(){
	let excluded = [];
	if (localStorage.getItem("excluded")) {
		try {
			excluded = JSON.parse(localStorage.getItem("excluded"))
		} catch (error) {
			console.log('not found')
		}
	}
	return excluded
}

export default {
	components: {
		InnerMenuCarousel,
		Hooper,
		Slide,
		HooperPagination
	},
	props: {
		menuItems: {
			type: Array,
			required: false
		}
	},
	data: () => ({}),
	computed: {
		/* menu(){
			const matched = this.$route.matched;
			const route = matched[matched.length - 1];
			const routePath = matched[matched.length - 1].path;
			let menu = this.getChildrenByPath(routePath)
			if (typeof menu  == 'undefined') {
				menu = this.getChildrenByPath(route.parent ? route.parent.path : undefined)
				if (typeof menu  == 'undefined') {
					menu = this.getChildrenByPath(route.parent.parent ? route.parent.parent.path : undefined)
				}
			}
			return menu
		}, */
		menu(){
			const matched = this.$route.matched;
			let parentRoute = this.$router.options.routes.find((routeitem) => routeitem.name == matched[0].name)
			const route = matched[matched.length - 1];
			const routePath = matched[matched.length - 1].path;
			let excluded = getExcluded()
			let menu = parentRoute.children ? parentRoute.children.filter( (routeitem) => (!routeitem.meta || !routeitem.meta.isVirtualNav) && !excluded.includes(routeitem.name) ) : [parentRoute]
			return menu
		},
		currentMenuIndex(){
			const indexMatch = (path) => path.name == this.$route.name
			let index = this.menu.findIndex(indexMatch)
			return index
		},
		currentMenuParent(){
			return this.$route.matched[0]
		}
	},
	watch: {
		$route(to, from) {
			let newIndex = this.getCurrentRouteMenuIndex()
			if (newIndex > -1) {
				this.$refs.menuCarousel.slideTo(this.getCurrentRouteMenuIndex())
			}
		}
	},
	mounted() {
		// this.scrollTop();
		this.innerSwipeHandler();
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		scrollTop(main_id = "#main_content") {
			$("html, body").animate(
				{
					scrollTop: ($(main_id).offset().top = -56)
				},
				0
			);
		},
		innerSwipeHandler() {
			this.scrollTop("#hopper_carousel");
		},
		navigateToRoute(payload){
			let newRouteName = this.menu[payload.currentSlide].name
			if (newRouteName != this.$route.name) {
				this.$router.push({ name: newRouteName })
			}
		},
		getCurrentRouteMenuIndex(){
			const indexMatch = (path) => path.name == this.$route.name
			let index = this.menu.findIndex(indexMatch)
			return index
		},
		getChildrenByPath(path) {
			let children = this.$router.options.routes;
			if (path) {
				// clean up empty elements
				let chunks = path.split('/');
				chunks = chunks.filter((chunk) => chunk !== '' && !chunk.includes(':') );

				if (chunks.length) {
					chunks.forEach((chunk, index) => {
						let path = chunk;
						if (index === 0) path = `/${path}`;

						if (children) {
							const found = children.find((child) => child.path === path);
							if (found) {
								if (found.children) {
									let excluded = getExcluded()
									let foundchildrens = found.children.filter((child) => (typeof child.meta == 'undefined' || child.meta.isVirtualNav !== true) && !excluded.includes(child.name))
									if (foundchildrens.length) {
										children = foundchildrens;
									} else {
										children = undefined
									}
								} else {
									children = undefined
								}
							}
						}
					});
				}
			}

			return children;
		},
	}
};
</script>

<style scoped lang="scss" src="./ItemMenuSlider.scss">
</style>